// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"633":"9ce59f64","956":"8a5d0e83"}[chunkId] + ".chunk.js";
};